import { useQuery } from '@tanstack/react-query'
import { staffAPI } from '../../api'
import { useBooking } from '../../context/BookingContext'
import { RiArrowLeftLine, RiArrowRightLine, RiCheckLine, RiStarFill } from 'react-icons/ri'
import toast from 'react-hot-toast'

export default function SelectStaff() {
  const { booking, setStaff, nextStep, prevStep } = useBooking()

  const serviceIds = booking.services.map((s) => s.id).join(',')

  const { data: staffList, isLoading } = useQuery({
    queryKey: ['staff-available', serviceIds],
    queryFn: () => staffAPI.getAvailable({ service_ids: serviceIds }),
    select: (r) => r.data?.data || [],
  })

  const handleNext = () => {
    if (!booking.staff) { toast.error('Please select a stylist'); return }
    nextStep()
  }

  const anyStaff = { id: 'any', name: 'Any Available Stylist', speciality: 'We\'ll assign the best available stylist', rating: null, avatar: null }
  const all = [anyStaff, ...(staffList || [])]

  return (
    <div>
      <h2 className="font-display text-salon-dark text-2xl font-bold mb-1">Choose a Stylist</h2>
      <p className="text-salon-muted font-body text-sm mb-6">Select your preferred stylist or let us assign one for you.</p>

      {isLoading ? (
        <div className="grid sm:grid-cols-2 gap-4">
          {[...Array(4)].map((_, i) => <div key={i} className="skeleton h-28 rounded-2xl" />)}
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {all.map((staff) => {
            const selected = booking.staff?.id === staff.id
            return (
              <button
                key={staff.id}
                onClick={() => setStaff(staff)}
                className={`text-left p-5 rounded-2xl border-2 transition-all duration-200 flex items-center gap-4 ${
                  selected
                    ? 'border-salon-primary bg-salon-primary/5 shadow-salon-sm'
                    : 'border-salon-cream-dark bg-white hover:border-salon-primary/40'
                }`}
              >
                <div className="relative shrink-0">
                  <div className="w-14 h-14 rounded-2xl bg-salon-primary/10 flex items-center justify-center overflow-hidden">
                    {staff.avatar ? (
                      <img src={staff.avatar} alt={staff.name} className="w-full h-full object-cover" />
                    ) : (
                      <span className="font-display text-salon-primary text-xl font-bold">
                        {staff.name.charAt(0)}
                      </span>
                    )}
                  </div>
                  {selected && (
                    <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-salon-primary flex items-center justify-center">
                      <RiCheckLine className="text-white text-xs" />
                    </div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-semibold font-body text-salon-dark">{staff.name}</p>
                  <p className="text-salon-muted text-xs font-body truncate mt-0.5">{staff.speciality}</p>
                  {staff.rating && (
                    <div className="flex items-center gap-1 mt-1">
                      <RiStarFill className="text-salon-secondary text-xs" />
                      <span className="text-xs font-body text-salon-muted">{staff.rating}</span>
                    </div>
                  )}
                </div>
              </button>
            )
          })}
        </div>
      )}

      <div className="flex justify-between mt-8">
        <button onClick={prevStep} className="btn-ghost">
          <RiArrowLeftLine /> Back
        </button>
        <button onClick={handleNext} className="btn-primary">
          Continue <RiArrowRightLine />
        </button>
      </div>
    </div>
  )
}
